export default __webpack_public_path__ + "7abb756a149f8d287001dd7f01bf44ac.png";